/**
 * .timepicker
 * Bind timepickers
 *
 * @package:  Betta
 * @version:  2.0
 * @author:   Cyrill N KALITA
 */

$(function()
{
    "use strict";

    // Enforce Snap to Step
    $.fn.timepicker.defaults.snapToStep = true;

    // Counter Step
    $.fn.timepicker.defaults.minuteStep = 1;

    // Do not fall back to current time
    $.fn.timepicker.defaults.defaultTime = "10:00 AM";

    // Do not dshow text inputs
    $.fn.timepicker.defaults.showInputs = true;

    // Lazy loading
    // Add data-provide="timepicker" to enable the timepicker or call the function below manually
    // $('.timepicker').timepicker();
});

